export const TokenIdRules = [
  {
    required: true,
    message: 'Please set the token id',
  },
];
